<template>
  <v-card flat color="secondary" class="footer-card">
    <v-container>
      <h3 class="headline">Learn More</h3>

      <p class="pt-4">
        Learn more about
        <a href="https://www.t-mobile.com/customers/scam-shield" v-if="isMagenta">
        T-Mobile's call protections
        </a>
        <a href="https://www.metrobyt-mobile.com/scam-shield" v-else>
        Metro by T-Mobile's call protections
        </a>.<br/>
        Learn more about call protection provided by these government agencies.
        <a href="https://www.fcc.gov/consumers/guides/stop-unwanted-robocalls-and-texts">FCC</a>
        and <a href="https://www.consumer.ftc.gov/articles/0208-phone-scams">FTC</a>
      </p>
      <p>
        T-Mobile partners with First Orion to provide this service.
        Your feedback will be shared with First Orion to improve
        service performance:
        <a href="http://firstorion.com/privacy-policy/">Privacy Policy</a>
      </p>
    </v-container>
  </v-card>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import config from '@/config'

@Component
export default class Footer extends Vue {
  private get isMagenta () {
    return config.isMagenta
  }
}
</script>
